import * as styles from "./ContractEditor.css";

import type { JSX } from "react";

import { Button } from "@frontend/components/atoms/Button";
import { Trans } from "@lingui/react/macro";

import { ContractEditorBody } from "./components/ContractEditorBody";
import {
  type UseContractEditorOptions,
  useContractEditor,
} from "./hooks/useContractEditor";

export type ContractEditorProps = UseContractEditorOptions;

export function ContractEditor({
  projectId,
  contractId = null,
  onSaved,
  onCancel,
}: ContractEditorProps): JSX.Element {
  const { loading, saving, error, conflict, save, cancel } = useContractEditor({
    projectId,
    contractId,
    onSaved,
    onCancel,
  });

  return (
    <div className={styles.editor}>
      <ContractEditorBody loading={loading} error={error} conflict={conflict} />

      <footer className={styles.footer}>
        <Button variant="ghost" onClick={cancel}>
          <Trans>Cancel</Trans>
        </Button>

        <Button
          variant="primary"
          loading={saving}
          disabled={loading}
          onClick={() => void save()}
        >
          <Trans>Save</Trans>
        </Button>
      </footer>
    </div>
  );
}
